import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ContractsFeatureService } from 'src/app/modules/contracts/contracts-feature.service';

/**
 * Bloquea la ruta `/contracts` cuando la firm actual NO tiene Contratos v2
 * activo (flag `firm.contracts_v2`, DEVS-380). Sin este guard el módulo era
 * accesible por URL directa aunque el flag estuviera desactivado en la DB.
 *
 * Usa el punto de decisión ÚNICO `ContractsFeatureService.isV2Enabled()`, el
 * mismo que gatea el item del sidebar y la solapa societaria.
 */
@Injectable({
  providedIn: 'root',
})
export class ContractsEnabledGuard {
  constructor(
    private contractsFeature: ContractsFeatureService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.contractsFeature.isV2Enabled()) {
      return true;
    }
    return this.router.parseUrl('/companies/list');
  }
}
